import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import {MatDialog as MatDialog,MatDialogConfig as MatDialogConfig } from "@angular/material/dialog";
import { AbstractControl, FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import { slideTrigger } from "src/app/events-calendar/common/animation/triggers/slideTrigger";
import { AddEditDescriptionComponent } from "../add-edit-description/add-edit-description.component";
import { PagesService } from "../pages.service";
import { distinctUntilChanged, map, switchMap, take, tap } from "rxjs/operators";
import { AddPageToMenuComponent } from "../add-page-to-menu/add-page-to-menu.component";
import { SiteService } from "src/app/services/site.service";
import { EStatus } from "src/app/models/general-enums";
import { forkJoin, of } from "rxjs";
import { MediaDialogComponent } from "src/app/new-media/new-media-manager/media-dialog/media-dialog.component";
import { SiteMenuService } from "src/app/site-menu/site-menu/common/services/site-menu.service";
import { animate, state, style, transition, trigger } from "@angular/animations";
import { AddEditMetaComponent } from "src/app/modules/content/add-edit-meta/add-edit-meta.component";
import { PagesSlugsComponent } from "src/app/site-menu/pages-slugs/pages-slugs.component";
import { MediaService } from "src/app/new-media/common/media.service";

@Component({
  selector: 'app-add-edit-page',
  templateUrl: "./add-edit-page.component.html",
  styleUrls: ["./add-edit-page.component.css"],
  animations: [
    slideTrigger,
    trigger('zipper', [
      state('collapsed', style({
        height: '0px',
        overflow: 'hidden',
        paddingTop: '0px',
        paddingBottom: '0px'
      })),
      state('expanded', style({
        height: '*',
        paddingTop: '*',
        paddingBottom: '*'
      })),
      transition('collapsed <=> expanded', [
        animate('400ms ease-in-out')
      ])
    ])
  ]
})
export class AddEditPageComponent implements OnInit {

  constructor(
    private mediaManagerService :MediaService,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    public pagesService: PagesService,
    public siteService: SiteService,
    public siteMenuService: SiteMenuService,
    private router: Router) { }


  siteCultures: any[];

  form: FormGroup = new FormGroup({
    cultures: new FormArray([], Validators.required)
  });

  isUpdated: true;

  activeTab: any = 0;
  activeInnerTab: any = 1;

  isEditPage = false;
  isDuplicatePage = false;
  public duplicatedOfId = 0;

  selectedLoginRequiredVal = null;
  categoryWithSepatatedCulture={}
  ngOnInit() {
    this.mediaManagerService.getfolderId=null
    this.siteService.getUsedSiteCultures(2)
      .pipe(
        switchMap((res) => {
          
      //     this.siteCultures = res;
      //     this.siteCultures.forEach(x=>this.categoryWithSepatatedCulture[x.name]=[])
      
      // this.pagesService.categories$.subscribe(x=>x.forEach(x=>{
      //   if(this.categoryWithSepatatedCulture[x.cultureCode])
      //   this.categoryWithSepatatedCulture[x.cultureCode].push(x)
      // }))
      this.siteCultures = res;
this.siteCultures.forEach(culture => this.categoryWithSepatatedCulture[culture.name] = []);
 
this.pagesService.categories$.subscribe(categories => {
  categories.forEach(category => {
category.categoryDetails.forEach(x=>{
  if (this.categoryWithSepatatedCulture[x.cultureCode]) {
      this.categoryWithSepatatedCulture[x.cultureCode].push(x);
    }
})
 
  });
});
          return this.route.paramMap;
        }),
        switchMap((params) => {
          if (params.get('id')) {

            this.isEditPage = true;
            this.isDuplicatePage = params.get('duplicated') ? true : false;

            if (this.isDuplicatePage) {
              this.duplicatedOfId = +params.get('id');
            }


            return forkJoin([
              this.pagesService.getRelatedPages(+params.get('id')),

              this.pagesService.getMenusByParentPageId(+params.get('id'))
            ])
          }
          else { return of(null) }
        }),
        map((res: any[]) => {
          let result;
          if (res) {
            result = res[0].map(x => {
              const target = res[1].find(y => y.pageId === x.id);
              return {
                ...x,
                // menuId: (!this.isDuplicatePage && target) && target.id ? target.id : null,
                menuCategory: (!this.isDuplicatePage && target) ? target.menuGroup.categoryId : null,
                menuGroupId: (!this.isDuplicatePage && target) ? target.menuGroupId : null,
                name: this.isDuplicatePage ? x.name.concat(' (duplicated)') : x.name,
                slug: this.isDuplicatePage ? x.slug.concat('-duplicated') : x.slug,
              }
            });
            return result;
          }
        }),
      )
      .subscribe(
        (res) => {
          if (res) {
            this.form.setControl('cultures', this.setEditPageCultures(this.siteCultures, res));
          }
          else {
            this.form.setControl('cultures', this.setNewPageCultures(this.siteCultures));
          }

          for (let index in this.siteCultures) {
                       if(index == "move") {
              continue;
            }
            if (this._cultures.controls[index].get('status').value) {
              this._cultures.controls[index].get('name').setValidators([Validators.required]);
              this._cultures.controls[index].get('name').updateValueAndValidity();
              this._cultures.controls[index].get('slug').setValidators([Validators.required, Validators.pattern(/^\S*$/)]);
              this._cultures.controls[index].get('slug').updateValueAndValidity();
              this._cultures.controls[index].get('pageCategoryId').setValidators([Validators.required, Validators.pattern(/^[1-9][0-9]*/)]);
              this._cultures.controls[index].get('pageCategoryId').updateValueAndValidity();
            }
            else {
              this._cultures.controls[index].get('name').clearValidators();
              this._cultures.controls[index].get('name').updateValueAndValidity();
              this._cultures.controls[index].get('slug').clearValidators();
              this._cultures.controls[index].get('slug').updateValueAndValidity();
              this._cultures.controls[index].get('pageCategoryId').clearValidators();
              this._cultures.controls[index].get('pageCategoryId').updateValueAndValidity();
            }


            this._cultures.controls[index].get('status').valueChanges
              .pipe(
                distinctUntilChanged()
              )
              .subscribe(
                status => {
                  if (status) {
                    this._cultures.controls[index].get('name').setValidators([Validators.required]);
                    this._cultures.controls[index].get('name').updateValueAndValidity();
                    this._cultures.controls[index].get('slug').setValidators([Validators.required, Validators.pattern(/^\S*$/)]);
                    this._cultures.controls[index].get('slug').updateValueAndValidity();
                    this._cultures.controls[index].get('pageCategoryId').setValidators([Validators.required, Validators.pattern(/^[1-9][0-9]*/)]);
                    this._cultures.controls[index].get('pageCategoryId').updateValueAndValidity();
                  }
                  else {
                    this._cultures.controls[index].get('name').clearValidators();
                    this._cultures.controls[index].get('name').updateValueAndValidity();
                    this._cultures.controls[index].get('slug').clearValidators();
                    this._cultures.controls[index].get('slug').updateValueAndValidity();
                    this._cultures.controls[index].get('pageCategoryId').clearValidators();
                    this._cultures.controls[index].get('pageCategoryId').updateValueAndValidity();
                  }
                }
              )

            this._cultures.controls[index].patchValue({ status: this._cultures.controls[index].get('status').value });

            if (!this.isEditPage) {
              this._cultures.controls[index].get('name').valueChanges
                .pipe(distinctUntilChanged())
                .subscribe(
                  value => {
                    if (this._cultures.controls[index].get('slug').pristine) {
                      this._cultures.controls[index].patchValue({
                        slug: value.replace(/\s/g, '-')
                          .replace(/\'+/g, "-").replace(/[^a-zA-Z0-9\u0600-\u06FF]/g, "-")
                          .toLowerCase()
                      })
                    }
                  }
                )
            }

          }
        }
      )
      
    this.pagesService.getPageTemplates();
  }

  updateActiveTab(v) {
    this.activeTab = this.activeTab == v ? null : v;
    this.activeInnerTab = 1;
  }
  updateSlug(index) {
    if (!this._cultures.controls[index].get('slug').value)
      this._cultures.controls[index].patchValue({
        slug: this._cultures.controls[index].get('name').value.replace(/\s/g, '-')
          .replace(/\'+/g, "-")
          .toLowerCase()
      })
  }
  updateActiveInnerTab(v) {
    this.activeInnerTab = this.activeInnerTab === v ? 0 : v;
  }

  setNewPageCultures(culturesSet): AbstractControl {
    const formArray = [];
    let i = 0;

    for (let item of culturesSet) {
      const group = new FormGroup({
        status: new FormControl(false),
        name: new FormControl(''),
        cultureId: new FormControl(item.id),
        pageTemplateId: new FormControl(null),
        description: new FormControl(''),
        metaDescription: new FormControl(''),
        additionalContent: new FormControl(''),
        thumbnailId: new FormControl(''),
        thumbnailURL: new FormControl(''),
        addtionalMetaTags: new FormArray([]),
        menuCategory: new FormControl(null),
        menuGroupId: new FormControl(null),
        menuId: new FormControl(null),
        addPageTo: new FormControl(1),
        cultureName: new FormControl(item.name),
        slug: new FormControl(''),
        id: new FormControl(0),
        parentId: new FormControl(0),
        pageCategoryId: new FormControl(0, Validators.pattern(/^[1-9][0-9]*/)),
        isLoginRequired: new FormControl(false),
        loginPage:  new FormControl(null)
        
      });

      formArray.push(group);
      i++;
    }

    return new FormArray(formArray)
  }

  setEditPageCultures(culturesSet, payload: any[]): AbstractControl {
    const formArray = [];
    let i = 0;
    let firstPublishedTab = -1;
    for (let item of culturesSet) {
      const target = payload.find(x => x.cultureId === item.id)
      
      const group = new FormGroup({
        status: new FormControl(target ? (target.status === 1 ? false : true) : false),
        name: new FormControl(target ? target.name : ''),
        cultureId: new FormControl(item.id),
        pageTemplateId: new FormControl(target ? target.pageTemplateId : null),
        // description: new FormControl(target ? target.description : ''),
        description: new FormControl(target ? target.description : ''),
        metaDescription: new FormControl(''),
        additionalContent: new FormControl(target ? target.additionalContent : ''),
        thumbnailId: new FormControl(target ? target.thumbnailId : ''),
        thumbnailURL: new FormControl(target && target.thumbnail ? target.thumbnail.publicUrl : ''),
        menuCategory: new FormControl(target ? target.menuCategory : null),
        menuGroupId: new FormControl(target ? target.menuGroupId : null),
        menuId: new FormControl(target ? target.menuId : null),
        addPageTo: new FormControl(target && target.menuId ? 2 : 1),
        cultureName: new FormControl(item.name),
        slug: new FormControl(target ? target.slug : ''),
        addtionalMetaTags: new FormArray([]),
        id: new FormControl(target ? target.id : 0),
        parentId: new FormControl(target ? target.parentId : 0),
        pageCategoryId: new FormControl(target ? target.pageCategoryId : 0),
        isLoginRequired: new FormControl(target ? target.isLoginRequired : false),
        loginPage: new FormControl(target ? target.loginPage : null)
      });

      let meta = target && target.addtionalMetaTags ? JSON.parse(target.addtionalMetaTags) : [];

      if (meta.length > 0) {
        let descriptionIndex = -1;
        let addedDescription = '';

        for (let i = 0; i < meta.length; i++) {
          for (let j = 0; j < meta[i].length; j++) {
            if (meta[i][j].value === 'description') {
              descriptionIndex = i;
             
              if (meta[i][j + 1]) {
                addedDescription = meta[i][j + 1].value;
              }
       
              meta[i].splice(j, 2);
              break;
            }
          }
        
          if (descriptionIndex >= 0) {
            break;
          }
        }
        
        meta = meta.filter(group => group.length > 0);
        if (descriptionIndex >= 0) {
          group.patchValue({ metaDescription: addedDescription });
        }
        group.setControl('addtionalMetaTags', this.setAddedMeta(meta));
      }

      formArray.push(group);
      if (firstPublishedTab === -1 && target && target.status !== 1) {
        this.activeTab = i;
      }

      i++;
    }

    return new FormArray(formArray)
  }

  isOneCultureActive() {
    return (this._cultures.value as any[]).find(x => x.status)
  }


  updatePage() {

  }
  updatePageSlug(newValue: string, cultureIndex: number) {
    this._cultures.controls[cultureIndex].patchValue({ slug: newValue })
  }

  //#region page menu
  managePageMenu(index: number) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      menuCategoryId: this._cultures.controls[index].get('menuCategory').value,
      menuGroupId: this._cultures.controls[index].get('menuGroupId').value,
      menuOptions: this._cultures.controls[index].get('addPageTo').value,
      // menuId: this._cultures.controls[index].get('menuId').value,
    };

    this.dialog.open(AddPageToMenuComponent, dialogConfig,)

      .afterClosed()
      .subscribe(
        res => {
          if (res) {
            this._cultures.controls[index].patchValue({
              menuCategory: Number(res.menuCategoryId),
              menuGroupId: Number(res.menuGroupId),
              addPageTo: Number(res.menuoptions),
              menuId: Number(res.menuoptions) == 2 ? Number(res.menuId) : null
            })
          }
        }
      )
  }

  getMenuCategoryName(categoryId) {
    if (!categoryId) { return 'Not selected'; }

    let menuCategories;
    this.siteMenuService.menuCategories$.pipe(take(1)).subscribe(res => menuCategories = res);

    const target = menuCategories.find(x => x.id === categoryId);
    return target ? target.name : 'Not selected';
  }

  getMenuGroupName(groupId) {
    if (!groupId) { return 'Not selected'; }

    let menuGroups;
    this.siteMenuService.MenuGroups$.pipe(take(1)).subscribe(res => menuGroups = res);

    const target = menuGroups.find(x => x.id === groupId);
    return target ? target.name : 'Not selected';
  }
  //#endregion

  //#region meta data
  setAddedMeta(metaSet) {
    const formArray = [];

    for (let meta of metaSet) {
      const isMetaDescription = meta.find(attr => attr.value === 'description');
      if (!isMetaDescription) {
        const arr = new FormArray([]);

        for (let attr of meta) {
          const fg = Object.keys(attr).reduce((obj, key) => Object.assign(obj, { [key]: new FormControl(attr[key]) }), {})
          arr.push(new FormGroup(fg))
        }

        formArray.push(arr);
      }

    }

    return new FormArray(formArray);
  }

  manageMeta(method: string, fg: FormGroup, metaTag?: any, index?: number) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;

    if (metaTag) {
      dialogConfig.data = metaTag.value;
    }

    this.dialog.open(AddEditMetaComponent, dialogConfig,)
      .afterClosed()
      .subscribe(
        res => {
          if (res) {
            switch (method) {
              case 'add':
                (fg.get('addtionalMetaTags') as FormArray).push(res);
                break;

              case 'edit':
                (fg.get('addtionalMetaTags') as FormArray).removeAt(index);
                (fg.get('addtionalMetaTags') as FormArray).insert(index, res);
            }
          }
        }
      )
  }

  removeMetaTag(fa: FormArray, index: number) {
    fa.removeAt(index)
  }
  //#endregion

  //#region description
  manageDescription(method: string, fg: FormGroup) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;

    dialogConfig.data = {
      method,
      payload: method === 'metaDescription' ? fg.get('metaDescription').value : fg.get('additionalContent').value
    };

    this.dialog.open(AddEditDescriptionComponent, dialogConfig).afterClosed().subscribe(
      res => {
        if (res != null) {
          switch (method) {
            case 'description':
              fg.patchValue({ 'description': res });
              break;

            case 'additionalContent':
              fg.patchValue({ 'additionalContent': res });
              break;
          }
        }
      }
    )
  }
  //#endregion

  //#region gallery
  openGallery(fg: FormGroup) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.position = { top: "0px", right: "0px" };
    dialogConfig.height = "100vh";
    dialogConfig.width = "50vw";
    dialogConfig.panelClass = "media-modal";
    //files (image , pdf , doc , excel , ppt , css ,js)
    dialogConfig.data = { isMultiSelect: false, files: ['image', '.webp','png','jpg'] };

    let dialogRef = this.dialog.open(MediaDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result) => {
      if (result.size>0) {

        for(const [key, value] of result.entries()){
          console.log(value)
          fg.patchValue({
            thumbnailId: value.id,      // nassar
            thumbnailURL: value.publicUrl,
          });
 
  
        }

       // fg.patchValue({ 'thumbnailId': result.id, 'thumbnailURL': result.publicUrl })
      }
    });
  }
  //#endregion

  deleteMedia(index) {
    this._cultures.controls[index].patchValue({ thumbnailId: null, thumbnailURL: null })
  }
  cancel() {

    if (this.isEditPage) {
      if (this.isDuplicatePage)
        this.router.navigate(['../../../'], { relativeTo: this.route })
      else
        this.router.navigate(['../../'], { relativeTo: this.route })
    }
    else this.router.navigate(['../'], { relativeTo: this.route })
  }
  submit(updated) {
   
    this.isUpdated = updated
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }


    else {

      let payload = this._cultures.value.map(culture => {
        let {
          name, cultureId, pageTemplateId,
          description, additionalContent, thumbnailId,
          slug, thumbnailURL, pageCategoryId, isLoginRequired, loginPage,loginPageId,
          metaDescription,
          addtionalMetaTags
        } = culture;

        if (metaDescription && metaDescription.length > 0) {
          addtionalMetaTags.push([{ key: 'name', value: 'description' }, { key: 'content', value: metaDescription }])
        }

        const id = this.isEditPage && !this.isDuplicatePage ? culture.id : 0;
        const parentId = this.isEditPage && !this.isDuplicatePage ? culture.parentId : 0;

        return {
          status: culture.status ? EStatus.Published : EStatus.Unpublished,
          addtionalMetaTags: JSON.stringify(addtionalMetaTags),
          name,
          cultureId,
          pageTemplateId,
          description,
          additionalContent,
          thumbnailId,
          slug,
          id,
          parentId,
          thumbnailURL,
          pageCategoryId,
          isLoginRequired,
          loginPageId: loginPage != null ? loginPage.parentId : null,
          duplicatedOfId: this.duplicatedOfId
        }
      });

      this.pagesService.submitAddEditPage(payload)
        .pipe(
          switchMap((res: any[]) => {
            const payload = this._cultures.value.map(culture => {
              const pageAndCultureIds = res.find(item => item.cultureId == culture.cultureId);

              return {
                id: 0,
                parentId: culture.addPageTo == 1 ? null : culture.menuId, // 1 root  , 2 child
                categoriesId: culture.menuCategory,
                menuGroupId: culture.menuGroupId,
                slug: culture.slug,
                Name: culture.name,
                status: culture.status ? EStatus.Published : EStatus.Unpublished,
                menuType: 2,
                pageId: +pageAndCultureIds.pageId,
                thumbnailId: culture.thumbnailId,
                thumbnailURL: culture.thumbnailURL,
                SlugTargetId: +pageAndCultureIds.pageId
              }
            })
            return of(payload);
          }),
          switchMap((res: any[],) => {
            res = res.filter(resItem => resItem.status == EStatus.Published && resItem.menuGroupId && resItem.categoriesId);
            if (res.length && !this.isEditPage) {
              return this.pagesService.savePagesMenu(res)
            }
            else {
              return of(null)
            }
          })
        )
        .subscribe((res) => {
          this.pagesService.openNotifySuccess('Updated Successfully');

          if(updated){ 
              return;
          }

          if (this.isDuplicatePage) {
            this.router.navigate(['../../../'], { relativeTo: this.route });
          }
          else if (this.isEditPage) {
            this.router.navigate(['../../'], { relativeTo: this.route });
          }
          else {
            this.router.navigate(['../'], { relativeTo: this.route });
          }


        });

    }
  }


  get _cultures() { return (this.form.get("cultures") as FormArray) }

  
  onRequiredLoginChange(event, cultureForm) {
    console.log(event.currentTarget.checked);
    console.log('this._cultures', cultureForm.get('isLoginRequired').value);
    if (cultureForm.get('isLoginRequired').value === true) {
      cultureForm.get('loginPage').setValidators([Validators.required])
    } else {
      cultureForm.get('loginPage').setValue(null)
      cultureForm.get('loginPage').clearValidators();
      cultureForm.get('loginPage').updateValueAndValidity();
    }
  }

  onSelectLoginRequired(source, cultureForm: FormGroup) {
    const cultureId = cultureForm.value.cultureId
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '50vw';
    dialogConfig.data = { source, cultureId };
    let modalRef;

    modalRef = this.dialog.open(PagesSlugsComponent, dialogConfig)
      .afterClosed()
      .subscribe((res) => {
        if (res) {
          
          console.log('modal result', res);
          console.log('modal cultureForm', cultureForm)
          
          cultureForm.get('loginPage').setValue(res);
        }
      })
  }
}

